<template>
    <b-container>
        <h1 class="mt-4">Requests</h1>
        <div v-if="nextDj">
            <b-row class="ml-1">
                <h3>Delete Next DJ</h3>
                <b-button @click="deleteNextDj" class="ml-2" variant="danger">
                    <font-awesome-icon icon="trash"/>
                </b-button>
            </b-row>
        </div>
        <div v-if="currentDj">
            <b-row class="ml-1">
                <h3>Delete Current DJ</h3>
                <b-button @click="deleteCurrentDj" class="mr-2" variant="danger">
                    <font-awesome-icon icon="trash"/>
                </b-button>
            </b-row>
        </div>
        <b-table class="mt-5" bordered :items="requests" :fields="fields" striped>
            <template slot="fileUrl" slot-scope="row">
                <div @click="viewImageLarge(row.item.fileUrl)">
                    <b-img-lazy style="cursor: pointer" height="100px" :src="row.item.fileUrl"/>
                </div>
            </template>
            <template slot="actions" slot-scope="row">
                <b-button @click="row.toggleDetails" class="mr-2">
                    <font-awesome-icon icon="music"/>
                </b-button>
                <b-button @click="confirmRequest(row.item._id)" variant="success" class="mr-2">
                    <font-awesome-icon icon="headphones"/></b-button>
                <b-button @click="deleteRequest(row.item._id)" variant="danger" class="mr-2">
                    <font-awesome-icon icon="trash"/></b-button>
                <b-button @click="markRequestDone(row.item._id)" class="mr-2" :variant="row.item.active ? 'warning' : 'success'">
                    <font-awesome-icon icon="check"/></b-button>
                <b-button @click="markNextDj(row.item._id)" class="mr-2" variant="info">
                    <font-awesome-icon icon="arrow-right"/></b-button>
                <b-button @click="markCurrentDj(row.item._id)" variant="primary">
                    <font-awesome-icon icon="hand-point-right"/></b-button>
            </template>

            <template slot="row-details" slot-scope="row">
                <b-card>
                    <b-table bordered responsive hover :items="row.item.tracks" :fields="reqFields"/>
                    <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                </b-card>
            </template>
        </b-table>
        <b-modal title="Are you sure?" header-bg-variant="danger" centered ref="deleteReqModal" @ok="doDeleteRequest" no-close-on-backdrop no-close-on-esc style="color: #FFFFFF">
            <div class="d-block text-center" style="color: black">
                Are you sure you want to delete this request?
            </div>
        </b-modal>
        <b-modal title="Confirm Request" header-bg-variant="info" centered ref="confirmReqModal" @ok="doConfirmRequest" no-close-on-backdrop no-close-on-esc style="color: #FFFFFF">
            <div class="d-block" style="color: black">
                <h2>Confirm set time</h2>
                <date-picker v-model="date" :config="options"/>
                <b-form-input class="mt-3" v-model="time" type="time" placeholder="Enter set time" />
            </div>
        </b-modal>
        <b-modal ref="modalImageView" ok-only centered size="lg">
            <div class="d-block text-center">
                <b-img-lazy style="width: 100%" :src="selectedImage"/>
            </div>
        </b-modal>
    </b-container>
</template>

<script>
    import { EventBus } from "../../EventBus";
    // Import required dependencies
    import 'bootstrap/dist/css/bootstrap.css';
    // Import this component
    import datePicker from 'vue-bootstrap-datetimepicker';
    // Import date picker css
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: "RequestsView",
        components: {datePicker},
        data() {
            return {
                requests: [],
                activeRequestId: '',
                fields: ['djName', {
                    // A column that needs custom formatting,
                    // calling formatter 'fullName' in this app
                    key: 'fileUrl',
                    label: 'Image',
                }, 'name', 'phone', 'email', 'actions'],
                reqFields: ['artist', 'track', 'genre'],
                date: new Date(),
                options: {
                    format: 'DD/MM/YYYY',
                    useCurrent: false,
                },
                time: '',
                selectedImage: '',
                nextDj: null,
                currentDj: null
            }
        },
        mounted() {
            this.getBookings();
            this.getNextDj();
            this.getCurrentDj();
            setInterval(async () => {
                await this.getNextDj();
                await this.getCurrentDj();
            }, 60000);
        },
        methods: {
            getBookings() {
                EventBus.$emit('loading-show');
                this.$axios.get('booking').then(result => {
                    EventBus.$emit('loading-hide');
                    this.requests = result.data;
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            deleteRequest(id) {
                this.activeRequestId = id;
                if (this.$refs.deleteReqModal) {
                    this.$refs.deleteReqModal.show();
                }
            },
            doDeleteRequest() {
                EventBus.$emit('loading-show');
                this.$axios.delete(`booking/${this.activeRequestId}`).then(() => {
                    this.$refs.deleteReqModal.hide();
                    EventBus.$emit('message', {message: 'Request has been deleted successfully', type: 'success'});
                    this.activeRequestId = '';
                    this.getBookings();
                    EventBus.$emit('loading-hide');
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            confirmRequest(id) {
                this.activeRequestId = id;
                if (this.$refs.confirmReqModal) {
                    this.$refs.confirmReqModal.show();
                }
            },
            doConfirmRequest() {
                EventBus.$emit('loading-show');
                let dateToSend = new Date(this.date);
                const timeSplit = this.time.split(':');
                dateToSend.setHours(parseInt(timeSplit[0]));
                dateToSend.setMinutes(parseInt(timeSplit[1]));
                this.$axios.put(`booking/${this.activeRequestId}`, {setTime: dateToSend, phone: this.requests[this.requests.findIndex(x => x._id === this.activeRequestId)].phone}).then(() => {
                    EventBus.$emit('loading-hide');
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            viewImageLarge(file) {
                this.selectedImage = '';
                this.selectedImage = file;
                if (this.$refs.modalImageView) {
                    this.$refs.modalImageView.show();
                }
            },
            markRequestDone(id) {
                this.requests[this.requests.findIndex(x => x._id === id)].active = !this.requests[this.requests.findIndex(x => x._id === id)].active;
                EventBus.$emit('loading-show');
                this.$axios.put(`booking/status/${id}`, {active: this.requests[this.requests.findIndex(x => x._id === id)].active}).then(() => {
                    EventBus.$emit('loading-hide');
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            async markNextDj(id) {
                await this.axios.post(`signage/next/${id}`)
                .then(() => EventBus.$emit('message', {message: 'Next DJ Set', type: 'success'}))
                .catch(err => EventBus.$emit('message', {message: err.message, type: 'danger'}))
            },
            async markCurrentDj(id) {
                await this.axios.post(`signage/current/${id}`)
                    .then(() => EventBus.$emit('message', {message: 'Current DJ Set', type: 'success'}))
                    .catch(err => EventBus.$emit('message', {message: err.message, type: 'danger'}))
            },
            async getNextDj() {
                this.nextDj = await this.axios.get(`signage/next`).then(result => result.data);
            },
            async getCurrentDj() {
                this.currentDj = await this.axios.get(`signage/current`).then(result => result.data);
            },
            async deleteNextDj() {
                await this.axios.delete(`signage/next`);
                this.nextDj = null;
            },
            async deleteCurrentDj() {
                await this.axios.delete(`signage/current`);
                this.currentDj = null;
            }
        }
    }
</script>

<style scoped>

</style>

